__turbopack_context__.v({
  "passport_row_ctas": "DUMDOq_passport_row_ctas",
  "passport_row_description": "DUMDOq_passport_row_description",
  "passport_row_donate_button": "DUMDOq_passport_row_donate_button",
  "passport_row_explore_button": "DUMDOq_passport_row_explore_button",
  "passport_row_header": "DUMDOq_passport_row_header",
  "passport_row_learn_more_link": "DUMDOq_passport_row_learn_more_link",
  "passport_row_learn_more_link_button": "DUMDOq_passport_row_learn_more_link_button",
  "passport_row_make_another_donation_link": "DUMDOq_passport_row_make_another_donation_link",
  "passport_row_make_another_donation_link_button": "DUMDOq_passport_row_make_another_donation_link_button",
  "passport_row_title": "DUMDOq_passport_row_title",
});
